import { lazy } from "react";

export const ConnectedConfigWizardLazy = lazy(
  () => import("./ConnectedConfigWizard")
);
